import { useState } from "react";

import ProductsBody from "./content/ProductsBody";
import ProductsSidebar from "./content/ProductsSidebar";

import "./styles.scss";

const PrProducts = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedHost, setSelectedHost] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);

  const selectItemHandler = (product, host, sub = null) => {
    setSelectedProduct(product);
    setSelectedHost(host);
    setSelectedSub(sub);
  };

  return (
    <div className="products-container">
      <div className="products-container__header">
        <h1>Product Settings</h1>
        <p>You can configure and view the current settings of any product</p>
      </div>
      <div className="products">
        <ProductsSidebar
          onItemSelect={selectItemHandler}
          selectedHost={selectedHost}
          selectedSub={selectedSub}
        />
        <ProductsBody
          selectedProduct={selectedProduct}
          selectedHost={selectedHost}
          selectedSub={selectedSub}
        />
      </div>
    </div>
  );
};

export default PrProducts;
